<template>
    <div @click="selectGOC()" class="normal-goc">
        <div class="floating-price">
            <img class="lazyload" src="https://cdn.shopify.com/s/files/1/1363/8433/files/price_shape.svg?v=1720452978"/>
            <p>{{ goc | moneyFloatFormat }}</p>
        </div>
        <div v-if="isLoading">
            <div class="spinner-container">
                <div class="spinner"></div>
            </div>
        </div>
        <div v-else class="flicking-container">
            <img v-on:click.stop @click="nextSlide()" class="right-arrow lazyload" src="https://cdn.shopify.com/s/files/1/1363/8433/files/right_arrow.svg?v=1719422956"/>
            <img v-on:click.stop @click="prevSlide()" class="left-arrow lazyload" src="https://cdn.shopify.com/s/files/1/1363/8433/files/left_arrow.svg?v=1719422955"/>
            <Flicking ref="flicking" :options="{ align: 'prev', circular: true, preventDefaultOnDrag: true,preventClickOnDrag: true,renderOnlyVisible: true }">
                <div v-for="image of productImages" class="panel">
                    <img :src="image" class="lazyload flicker-image"/>
                </div>
            </Flicking>
        </div>
        <p class="happybox-button white border">View {{ goc | moneyFloatFormat }} Collection</p>
    </div>
</template>


<script>
export default {
    props:{
        goc: Object,
    },
    computed:{
        isLoading(){
            if(this.goc && this.goc.collectionProducts && this.goc.collectionProducts.length > 0){
                return false;
            }

            return true
        },
        productImages(){
            if(this.goc && this.goc.collectionProducts && this.goc.collectionProducts.length > 0){
                let reorder = this.goc.tags.find(x => x == "Image_Reorder");
                let products =  JSON.parse(JSON.stringify(this.goc.collectionProducts));
                if(reorder){
                    products = products.swapItems(0, 1)
                }
                return products.filter(x => x.images.length > 0).map(x => x.images[0].src);
            }

            return [];
        }
    },
    methods:{
        nextSlide(){
            this.$refs.flicking.next();
        },
        prevSlide(){
            this.$refs.flicking.prev();
        },
        selectGOC(){
            this.$emit("selectgoc",this.goc)
        }
    }

}
</script>

<style scoped>
  
    .normal-goc {
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 15px;
        width: 20%;
        border: 1px solid #e0e0e0;
        position: relative;
        align-items: center;
        background-color: white;
        border-radius: 8px;
    }

    .spinner-container{
        height: 230px;
        min-height: unset;
    }

    .product-title{
        font-size: 1.15vw;
        font-weight: bold;
        margin: unset;
    }

    .shop-now{
        color: #A01ADB;
        text-decoration: underline;
        font-weight: bold;
        font-size: 1vw;
    }

    .flicking-container{
        width: 100%;
        position: relative;
    }

    .flicker-image{
        width: 100%;
        aspect-ratio: 1;
        object-fit: cover;
    }

    .flicking-container .panel{
        width: 100%;
    }

    .right-arrow,.left-arrow{
        position: absolute;
        top: 45%;
        width: 20px;
        z-index: 2;
        cursor: pointer;
    }

    .right-arrow{
        right: -5%;
    }

    .left-arrow{
        left: -5%;
    }

    .floating-price{
        position: absolute;
        width: 25%;
        top: 5%;
        left: 5%;
        z-index: 2;
        display: flex;
    }

    .floating-price img{
        width: 100%;
    }

    .floating-price p{
        font-size: 1.3vw;
        line-height: 1;
        font-family: ff-more-web-pro-condensed, Karla, sans-serif;
        font-weight: 300;
        margin: unset;
        position: absolute;
        top: calc((100% - 1.15vw) / 2);
        width: 100%;
        text-align: center;
    }

    .happybox-button{
        width: 90%;
        margin: unset;
        font-size: .9vw;
    }

    @media screen and (max-width: 767px) {
        .product-title{
            font-size: 3.5vw;
        }

        .shop-now{
            font-size: 3vw;
            margin-bottom: unset;
        }

        .floating-price p{
            font-size: 3.5vw;
            top: calc((100% - 3.5vw) / 2);
        }

        .right-arrow,.left-arrow{
            width: 25px;
        }
        .happybox-button{
            font-size: 3vw;
        }
    }
</style>